import request from '@/utils/request'
import Vue from 'vue'

//  交易信息
export function getTransactionInformation(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.telVerificationCode + '/clesun/controller/v1.0/user/verifCode',
        params
    })
}

//  交易信息
export function userRegistration(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.telVerificationCode + '/clesun/controller/v1.0/user/userRegistration',
        data
    })
}

// 获取图形验证码
export function getCaptcha(params) {
    return request({
        method: 'GET',
        responseType: 'arraybuffer',
        url: Vue.prototype.telVerificationCode + '/clesun/controller/v1.0/captcha.jpg',
        params
    })
}

// 登录
export function loginIn(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.telVerificationCode + '/clesun/controller/v1.0/login',
        params
    })
}

// 找回密码
export function retrievePassword(params) {
    return request({
        method: 'GET',
        url: Vue.prototype.telVerificationCode + '/clesun/api/v1.0/user/retrievePassword',
        params
    })
}

// 忘记密码短信验证码
export function forgetPasswordVerifCode(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.telVerificationCode + '/clesun/api/v1.0/user/forgetPasswordVerifCode',
        params
    })
}
export function getExpertInfoByLoginUser(params) {
    return request({
        method: 'GET',
        url: Vue.prototype.telVerificationCode + '/clesun/controller/v1.0/user/getExpertInfoByLoginUser',
        params
    })
}
